import {runInAction} from 'mobx'
import {observer} from 'mobx-react-lite'
import React, {useEffect, useRef} from 'react'
import {HTMLUtil} from 'yougile-util'
import {Hub} from 'yougile-model'
import {ReactPortal} from '@components/common/react-portal/react-portal'
import {CustomCKEditor} from '@components/right-panel/task-description/ck-editor'
import {TwFullscreenContainer, TwMainContainer} from './containers'
import {EditorContainer} from './editor-container'
import {useOnObjectsClick} from './hooks/use-on-objects-click'
import {useSyncDescription} from './hooks/use-sync-description'
import {useTaskDescription} from './task-description-store'
import {TaskTitleInput} from './task-title-input'
import {TopPanel} from './top-panel/top-panel'

type Props = {
  hub: Hub
  newBg?: boolean
}

export const TaskDescriptionLayout = observer((props: Props) => {
  const {hub} = props
  const [state, store] = useTaskDescription()
  const editorContainerRef = useRef<HTMLDivElement>()
  const {edit} = state

  useSyncDescription({hub})

  const processImageClick = useOnObjectsClick(edit)

  useEffect(() => {
    setTimeout(() => {
      runInAction(() => {
        const html = HTMLUtil.sanitizeHtml(hub?.description || '')
        store.taskHub = hub
        store.updateContent(html)
      })
    }, 10)
    return () => {
      // force save with previous taskId
      void store.saveContent()
    }
  }, [hub?.id])

  const offset = 0

  return (
    <ReactPortal elementId="description-fullscreen" enabled={true}>
      <TwMainContainer id={'description-editor'} onClick={processImageClick}>
        <TopPanel />
        <TwFullscreenContainer style={{maxHeight: 'calc(100vh - 64px)'}}>
          <TaskTitleInput hub={hub} />
          <EditorContainer editorContainerRef={editorContainerRef}>
            <CustomCKEditor
              readonly={!edit}
              headerHeight={offset}
              value={
                state.contentChanged /* to save edited data when toggle to fullscreen mode */
              }
              onChange={store.onChange}
              kindOf={'task-template'}
            />
          </EditorContainer>
        </TwFullscreenContainer>
      </TwMainContainer>
    </ReactPortal>
  )
})
